import PatchController from '../PatchController';

// Custom controllers
import DashboardController from './DashboardController';
import DefaultController from './DefaultController';
import FavoritesController from './FavoritesController';
import MySuccessController from './MySuccessController';
import ProfileController from './ProfileController';
import ProgramFeedController from './ProgramFeedController';
import ProgramPreviewController from './ProgramPreviewController';
import ProgramsFurtherController from './ProgramsFurtherController';
import ProgramsRecommendedController from './ProgramsRecommendedController';

// Export abstract Patch controller for typing
export { PatchController };

// Controller bundle
export default {
	ProfileController,
	DefaultController,
	FavoritesController,
	MySuccessController,
	DashboardController,
	ProgramFeedController,
	ProgramPreviewController,
	ProgramsFurtherController,
	ProgramsRecommendedController,
};
